module.exports = __webpack_public_path__ + "static/media/1.b8aa7c77.jpeg";